export default __webpack_public_path__ + "static/media/logo-card-480w.0493e2d9.png";